export const routesByValue = {
  menus: {
    label: 'menus',
    value: '/menus',
  },
  createMenu: {
    label: 'create',
    value: '/menus/create',
    redirect: '/menus',
  },
  manageMenuLocations: {
    label: 'manage-locations',
    value: '/menus/manage-locations',
  },
  editMenu: {
    label: 'edit',
    value: '/menus/edit/:id',
    getRoute: (id) => `/menus/edit/${id}`,
  },
  pages: {
    label: 'pages',
    value: '/pages',
  },
  createPage: {
    label: 'create',
    value: '/pages/create',
    redirect: '/pages',
  },
  viewPage: {
    label: 'create',
    value: '/pages/view/:id',
    getRoute: (id) => `/pages/view/${id}`,
  },
  editPage: {
    label: 'edit',
    value: '/pages/edit/:id',
    getRoute: (id) => `/pages/edit/${id}`,
  },
  renderPage: {
    label: 'render',
    value: '/render',
  },
  managePageLocations: {
    label: 'manage-locations',
    value: '/pages/manage-locations',
  },
  globalBanner: {
    label: 'Global Banner',
    value: '/global-banner',
  },
  banners: {
    label: 'banners',
    value: '/banners',
  },
  categoryBanner: {
    label: 'Category Banner',
    value: '/banners/category',
  },
  createCategoryBanner: {
    label: 'create',
    value: '/banners/category/create',
    redirect: '/banners/category',
  },
  editCategoryBanner: {
    label: 'edit',
    value: '/banners/category/edit/:id',
    getRoute: id => `/banners/category/edit/${id}`,
  },
  tagBanner: {
    label: 'Tag Banner',
    value: '/banners/tag',
  },
  createTagBanner: {
    label: 'create',
    value: '/banners/tag/create',
    redirect: '/banners/tag',
  },
  editTagBanner: {
    label: 'edit',
    value: '/banners/tag/edit/:id',
    getRoute: id => `/banners/tag/edit/${id}`,
  },
  storeLocator: {
    label: 'Store Locator',
    value: '/store-locator',
  },
  manageStoreList: {
    label: 'Store Locator',
    value: '/store-locator/stores',
  },
  manageStoreLocatorTypes: {
    label: 'Store Locator',
    value: '/store-locator/types',
  },
};



// WEBPACK FOOTER //
// ./src/helpers/routesConstant.js